import { JunctionStatus } from "../../../../../../utils/Enum.types";
import {
  OrderDirection,
  commonMutationTypes,
  pageInfo,
} from "../../../../../../utils/commonQueryTypes";
import {
  AtsCompany,
  TableType,
} from "../../../../customer/companies/queries/types";
import { AtsJunctions, AtsTickets } from "../../../../mobileapp/queries/types";
import { AtsStckItem } from "../../../masters/items/queries/types";
import {
  AtsSubsidiary,
  AtsSubsidiarySite,
} from "../../../masters/subsidary/queries/types";

export interface DashboardVars {
  token?: string;
  customerID: number;
  empID: number;
}

// junction-count
export interface WorkingDataResult {
  total: number;
  working: number;
  notWorking: number;
}
export interface vendorWiseDataResult {
  vendorName: string;

  total: number;
  WorkingData: WorkingDataResult;
}
export interface detailedChartList {
  jType: string;
  count: number;
  vendorWiseData: vendorWiseDataResult[];
}

export interface totalCountDataResult {
  total: number;
  working: number;
  notWorking: number;
}
export interface signalTypeDataResult {
  jType: string;
  count: number;
  working: number;
  notWorking: number;
}
export interface vendorWiseDataResult {
  vendorName: string;
  total: number;
  working: number;
  notWorking: number;
}

export interface TotalTicketCount {
  raisedTicket: number;
}

export interface GetDashboardJunctionCountList {
  detailedChart: detailedChartList[];
  totalCountData: totalCountDataResult;
  signalTypeData: signalTypeDataResult[];
  vendorWiseData: vendorWiseDataResult[];
  ticketCountData: TotalTicketCount;
}
export interface GetDashboardJunctionCountData {
  GetDashboardJunctionCount: GetDashboardJunctionCountList;
}

// item-count
export interface GetDashboardItemAndJunctionCountList {
  desc: string;
  count: number;
  id: number;
  tableLevel: TableType;
  icon: string;
}
export interface GetDashboardItemAndJunctionCountData {
  GetDashboardItemAndJunctionCount: GetDashboardItemAndJunctionCountList[];
}

// ticket-details

export interface GetDashboardTicketCountList {
  desc: string;
  count: number;
}
export interface GetDashboardTicketCountData {
  GetDashboardTicketCount: GetDashboardTicketCountList[];
}

// priority details

export interface GetDashboardTicketPriorityCountList {
  desc: string;
  count: number;
}
export interface GetDashboardTicketPriorityCountData {
  GetDashboardTicketPriorityCount: GetDashboardTicketPriorityCountList[];
}
//project details

export interface GetDashboardProjectDetailsList {
  id: number;
  name: string;
  startDate: string;
  endDate: string;
  vendor: string;
}
export interface GetDashboardProjectDetailsData {
  GetDashboardProjectDetails: GetDashboardProjectDetailsList[];
}

export interface GetDashboardJunctionStatusCountResult {
  junctionStatus: JunctionStatus;
  count: number;
}

export interface GetDashboardJunctionStatusCountVars {
  customerID: number;
  empID: number;
}

export interface GetDashboardJunctionStatusCountData {
  GetDashboardJunctionStatusCount: GetDashboardJunctionStatusCountResult[];
}

export interface AddStckRetrieItemDetailsResult {
  AddStckRetrieItemDetails: boolean;
}

export interface CreateAtsStckRetrieItemDetailsInput {
  retireDate?: string;
  prodSerialNo?: string;
  prodBatchNo?: string;
  prodBrand?: string;
  prodModel?: string;
  prodExpiryDate?: string;
  prodWarrantyStartDate?: string;
  prodWarrantyEndDate?: string;
  prodInstallationEndDate?: string;
  prodAmcStDate?: string;
  prodAmcEndDate?: string;
  prodInsuranceStDate?: string;
  prodInsuranceEndDate?: string;
  prodLatitude?: string;
  prodLongitude?: string;
  itemId: number;
  itemDetailsId: number;
  subsidiaryId: number;
  siteId: number;
  companyId: number;
  junctionId: number;
  ldgrId: number;
  remark?: string
}

export interface AddStckRetrieItemDetailsVar extends commonMutationTypes {
  customer_id: number;
  input: CreateAtsStckRetrieItemDetailsInput;
}

export enum AtsStckRetireItemDetailsOrderField {
  CREATED_AT = "CREATED_AT",
}

export interface AtsStckRetireItemDetailsOrder {
  direction: OrderDirection;
  field: AtsStckRetireItemDetailsOrderField;
}

export interface GetRetiredItemDetailsVar {
  token?: string;
  customerID: number;
  companyID: number;
  subsidiaryID: number;
  siteID: number;
  junctionID: number;
  itemDetailsID: number;
  startDate?: string;
  endDate?: string;
  after: string | null;
  first: number;
  orderBy: AtsStckRetireItemDetailsOrder;
  name: string;
}

export interface AtsStckRetireItemDetails {
  id: number;
  retireDate: string;
  prodSerialNo: string;
  prodBatchNo: string;
  prodBrand: string;
  prodModel: string;
  prodExpiryDate: string;
  prodWarrantyStartDate: string;
  prodWarrantyEndDate: string;
  prodInstallationEndDate: string;
  prodAmcStDate: string;
  prodAmcEndDate: string;
  prodInsuranceStDate: string;
  prodInsuranceEndDate: string;
  prodLatitude: string;
  prodLongitude: string;
  customerID: number;
  itemID: number;
  companyID: number;
  subsidiaryID: number;
  siteID: number;
  junctionID: number;
  ldgrID: number;
  subsidiaryDetails: AtsSubsidiary;
  company: AtsCompany;
  item: AtsStckItem;
  site: AtsSubsidiarySite;
  junction: AtsJunctions;
  remark: string;
}

export interface AtsStckRetireItemDetailsEdge {
  node: AtsStckRetireItemDetails;
  cursor: string;
}
export interface AtsStckRetireItemDetailsConnection {
  edges: AtsStckRetireItemDetailsEdge[];
  pageInfo: pageInfo;
  totalCount: number;
}

export interface GetRetiredItemDetailsResult {
  GetRetiredItemDetails: AtsStckRetireItemDetailsConnection;
}
